<template>
  <div v-if="carouselList.length">
    <ClientOnly v-if="!isMobile">
      <swiper-container
        ref="containerRef"
        :loop="carouselList.length > slidesPerView"
        :pagination="paginationConfig"
        :slides-per-view="slidesPerView"
        :slides-per-group="slidesPerGroup"
      >
        <swiper-slide
          v-for="item in carouselList"
          :key="item.name"
          class="h-auto p-2.5"
        >
          <slot name="card" :item="item" />
        </swiper-slide>
      </swiper-container>
    </ClientOnly>

    <ul v-else class="mb-6">
      <li v-for="item in carouselList" :key="item.name" class="mb-4">
        <slot name="card" :item="item" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts" generic="T extends { name: string }">
  interface IProps {
    carouselList: T[];
  }

  const props = withDefaults(defineProps<IProps>(), {
    carouselList: () => [],
  });

  const { isMobile, isDesktop } = useScreen();

  const slidesPerView = computed((): number => (isDesktop.value ? 4 : 2));
  const slidesPerGroup = computed((): number => (isDesktop.value ? 4 : 2));

  const paginationConfig = computed(
    (): { enabled: boolean; clickable: boolean } => {
      const itemCount = props.carouselList.length;
      const threshold = isDesktop.value ? 4 : 2;

      return {
        enabled: itemCount > threshold,
        clickable: true,
      };
    }
  );
</script>

<style lang="scss" scoped>
  swiper-container {
    &::part(pagination) {
      @apply static my-8 flex justify-center tablet:my-9;
    }

    &::part(bullet) {
      @apply mx-1.5 block h-1 w-10 overflow-hidden rounded-md bg-gray-400 opacity-100;
    }

    &::part(bullet-active) {
      @apply mx-1.5 block h-1 w-10 overflow-hidden rounded-md bg-blue-400;
    }
  }
</style>
